export class Sueldos_educacion{
    constructor(
        public diverso: Number,
        public nombre: String,
        public codigo_departamento: String,
        public nombre_departamento: String
    ){}
}